import React, { useState } from "react";
import { useQuery, useMutation } from "react-query";
import TableContainer from "../../../common/table/TableContainer";
import { getWebhookList, deleteWebhook } from "../service/api";
import { Menu, Dropdown, Button, Modal } from "antd";
import { EyeOutlined, DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { ModifyWebhookForm } from "./modifyWebhook";

export const MainPart = ({ selectedBusinessAccount }) => {

    // Session constants
    const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    const token = currentUser?.token;
    const queryClient = useQueryClient();

    // State variables
    const [selectedWebhook, setSelectedWebhook] = useState(null);
    const [modifyModal, setModifyModal] = useState(false);

    // Mutations
    const deleteWebhookMutation = useMutation(deleteWebhook);

    const { data: webhookList, isLoading, error: errorWebhook } = useQuery({
        queryKey: ["webhookList", selectedBusinessAccount, token],
        queryFn: getWebhookList,
        enabled: !!token
    });

    const deleteModal = (webhookId) => {
        Modal.warning({
            title: 'Supprimer un webhook',
            content: 'Êtes-vous sûr ? Cette action est irreversible.',
            bodyStyle: {
                width: 350
            },
            onOk: () => {
                deleteElement(webhookId);
            }
        });
    };

    const deleteElement = (webhookId) => {
        const values = {
            webhookId: webhookId,
            token: token
        }
        deleteWebhookMutation.mutate(values, {
            onSuccess: (response) => {
                toast.success("Webhook supprimé avec succès");
                queryClient.invalidateQueries({
                    predicate: (query) => query.queryKey[0] === 'webhookList',
                });
            },
            onError: (error) => {
                console.error(error);
            }
        })
    }

    const columns = [
        {
            Header: "Description webhook",
            accessor: "description",
            filterable: false,
            Cell: ({ value }) => <span>{value || "Non défini"}</span>
        },
        {
            Header: "URL du webhook",
            accessor: "url",
            filterable: false,
            Cell: ({ value }) => <span>{value || "Non défini"}</span>
        },
        {
            Header: "Date de création",
            accessor: "createdAt",
            filterable: false,
            Cell: ({ value }) => {
                return value ?
                    <span className="namesTrans" >
                        {new Date(value).toLocaleString("fr-FR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </span> :
                    <span> Non défini </span>
            }
        },
        {
            Header: "Action",
            Cell: ({ row }) => {
                return (<Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => {
                                setSelectedWebhook(row.original);
                                setModifyModal(true);
                            }}>
                                Modifier
                            </Menu.Item>
                             <Menu.Item key="4" icon={<DeleteOutlined />} onClick={() => deleteModal(row.original.id)} danger>
                                Supprimer
                            </Menu.Item>
                        </Menu>
                    }
                    trigger={["click"]}
                >
                    <div className="action-menu-trigger">
                        <EllipsisOutlined />
                    </div>
                </Dropdown>)
            }
        },
    ];
    return (
        <div className="mt-3">
            <TableContainer
                columns={columns}
                data={webhookList || []}
                isGlobalSearch={true}
                isGlobalFilter={true}
                customPageSize={10}
                className="custom-header-css"
                divClass="table-responsive table-card mb-3"
                tableClass="align-middle table-nowrap"
                theadClass="table-light"
                SearchPlaceholder="Recherche..."
                isLoading={isLoading}
                isError={errorWebhook}
            />
            <Modal
                title="Modification d'un webhook"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={modifyModal}
                onOk={() => setModifyModal(false)}
                onCancel={() => setModifyModal(false)}
                footer={false}
                bodyStyle={{ padding: 0, width: 400 }}
            >
                <ModifyWebhookForm webhook={selectedWebhook} businessAccountId={selectedBusinessAccount} showModifyModal={setModifyModal} style={{ width: "100%" }} />
            </Modal>
        </div>
    )
}